import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NavBelt from "../page-essentials/NavBelt";
import { BookingBreadCrupData } from "../static-data/breadcrump";
import { SubmitHandler, useForm } from "react-hook-form";
import ContactInfo from "../page-components/contact/ContactInfo";
import { IPackage } from "../../types/global";
import LangContext from "../../context/LangContext";
import PackagesService from "../../services/Packages.service";
import BookingService from "../../services/Booking.service";

export interface IBookingFormInput {
  name: string;
  email: string;
  country: string;
  phone: number;
  departure_date: Date;
  group_members: number;
  message: string;
  pkg: string;
}

interface IRouterProps {
  id: string;
  title: string;
}
const Booking = () => {
  const location = useLocation();
  const routerProps = location.state as IRouterProps | undefined;
  console.log(routerProps);

  const { lang_id } = useContext(LangContext);
  const [pkgData, setPkgData] = useState<IPackage[]>([]);
  const [apiRes, setApiRes] = useState<{
    type: string;
    message: string;
  }>();

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm<IBookingFormInput>();

  const fetchPkgs = async () => {
    try {
      const res = await PackagesService.fetchPackages("", lang_id);
      setPkgData(res.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };
  const onSubmit: SubmitHandler<IBookingFormInput> = async (data) => {
    try {
      const res = await BookingService.create(data);
      setApiRes({
        type: "success",
        message:
          "Booking has been successfully done. Our representative will contact you soon. Thank you.",
      });
      reset();
    } catch (error: any) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    if (lang_id) {
      fetchPkgs();
      if (routerProps && routerProps.id) {
        setValue("pkg", routerProps.id);
      }
    }
  }, [lang_id, setValue]);
  return (
    <div>
      <NavBelt
        page="Booking"
        img="https://images.unsplash.com/photo-1499803270242-467f7311582d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1073&q=80"
        breadCrumpInfo={BookingBreadCrupData}
      />

      <div className="container mx-auto px-4 2xl:px-12 my-8 2xl:my-12">
        <div className="grid grid-cols-12 gap-8">
          <form
            action=""
            onSubmit={handleSubmit(onSubmit)}
            className="space-y-4 col-span-8"
          >
            {apiRes?.type === "success" && (
              <div className="my-4 bg-primary-base p-2 text-white">
                {apiRes.message}{" "}
              </div>
            )}
            <div className="flex flex-col space-y-2">
              <label htmlFor="pkg">Package</label>
              <select
                id="pkg"
                className="form-input inputs"
                placeholder="John doe"
                {...register("pkg", { required: true })}
                disabled={routerProps && routerProps.id ? true : false}
              >
                {routerProps && routerProps.id ? (
                  <option value={routerProps.id}>{routerProps.title}</option>
                ) : (
                  <>
                    <option value="">--select pacakge--</option>
                    {pkgData.map((item, i) => (
                      <option key={item.id} value={item.id}>
                        {item.translation[0].package_title}
                      </option>
                    ))}
                  </>
                )}
              </select>
              {errors.pkg && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="name">Full name </label>
              <input
                type="text"
                id="name"
                className="form-input inputs"
                placeholder="John doe"
                {...register("name", { required: true })}
              />
              {errors.name && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="country">Address with country</label>
              <input
                type="text"
                id="country"
                className="form-input inputs"
                placeholder="Paris, France"
                {...register("country", { required: true })}
              />
              {errors.country && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="email">email</label>
              <input
                type="text"
                id="email"
                className="form-input inputs"
                placeholder="example@gmail.com"
                {...register("email", {
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors.email && (
                <span className="text-red-500">
                  {errors.email.message || "This field is required"}{" "}
                </span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="phone">Contact number</label>
              <input
                type="number"
                id="phone"
                className="form-input inputs"
                placeholder="+977-980000000"
                {...register("phone", { required: true })}
              />
              {errors.phone && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="group_members">No of Group members</label>
              <input
                type="number"
                id="group_members"
                className="form-input inputs"
                placeholder="04"
                {...register("group_members", { required: true })}
              />
              {errors.group_members && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="departure_date">Departure Date</label>
              <input
                type="Date"
                id="departure_date"
                className="form-input inputs"
                placeholder="+977-980000000"
                {...register("departure_date", { required: true })}
              />
              {errors.departure_date && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                rows={4}
                className="form-input inputs"
                placeholder="Write your message here..."
                {...register("message", { required: false })}
              />
              {errors.message && (
                <span className="text-red-500">This field is required</span>
              )}
            </div>

            <div className="flex flex-col space-y-2">
              <input
                type="submit"
                className="bg-primary-base px-3 py-2 text-white rounded-md cursor- transition cursor-pointer hover:bg-primary-dark-600"
                value={"Book now!"}
              />
            </div>
          </form>

          {/* right side  */}
          <div className="col-span-4 bg-gray-100 p-8 w-full">
            <div className="prose">
              <h2>We are always available for your service.</h2>
            </div>
            <hr className="mt-2 mb-8" />
            <ContactInfo />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
